import React from "react";
import Slider from "react-slick";
import "./RatingSlider.css";
import {Calendar} from "../../../assets/icons";
import SectionParagraph from "../../SectionParagraph";
import {useLanguage} from "../../../hooks/LanguageContext";

const RatingSliderBox = ({ sliders , swiperRef , setIsBeginning ,setIsEnd }) => {
	const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL; // Access the base URL
	const { direction } = useLanguage();

	// Slider settings
	const settings = {
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2.5,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1.1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 320,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
		arrows: false,
		clone : false

	};

	return (
		<Slider ref={swiperRef} {...settings} className="w-full h-[344px]">
			{sliders.map((slider) => (
				<div
					className="md:w-[547px] w-full h-full bg-bg-light md:rounded-[20px] rounded-lg md:p-[30px] p-4 shadow-aboutUs-shadow"
					key={slider.id}
				>
					<div
						className="w-full md:h-[284px] h-full flex flex-col items-start md:gap-[20px] gap-3"
						style={{ textAlign: direction === "rtl" ? "right" : "left" }}
					>
						<div className={`w-full flex items-center ${direction === 'rtl' ? 'justify-end' : 'justify-start'} gap-[21px]`}>

							<div className="flex flex-col items-end justify-start gap-3">
								<h5
									className="headline-5-ar text-grayscale-600 w-full"
									style={{ textAlign: direction === "rtl" ? "right" : "left" }}
								>
									{direction === "rtl" ? slider.name_ar : slider.name_en}
								</h5>
								<div className="flex items-center text-primary-700">
									{[...Array(slider.rating)].map((_, index) => (
										<svg
											key={index}
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24"
											className="w-6 h-6 fill-current"
										>
											<path d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z" />
										</svg>
									))}
								</div>
							</div>
							<img
								className={`max-w-[100px] max-h-[100px] ${direction === 'rtl' ? '' : 'order-first'}`}
								src={`${baseUrl}/${slider.image}`}
								alt={`${slider.name_en}-icon`}
							/>
						</div>
						<div className="w-full border-[1px] border-grayscale-100"></div>
						<div className={`w-full flex items-start ${direction === 'rtl' ? 'justify-start' : 'justify-end'}`}>
							<div className="flex gap-2 items-center">
								<Calendar />
								<SectionParagraph paragraph={slider.date} />
							</div>
						</div>
						<SectionParagraph
							align={direction === "rtl" ? "items-start" : "items-end"}
							paragraph={direction === "rtl" ? slider.opinion_ar : slider.opinion_en}
						/>
					</div>
				</div>
			))}
		</Slider>
	);
};

export default RatingSliderBox;
